import React from 'react'
import { PopType } from '../../types'
import { PopFormDefault } from './PopFormDefault'
import { RePOPForm } from './RePOPForm'
import { PopGPT } from './PopGPT'
import { FakeRePop } from './FakeRePop'
import { AIPop } from './AIPop'
import { AIRepopForm } from './AIRepop'

export const renderFormByType = (type: number) => {
  switch (type) {
    case PopType.Default:
      return <PopFormDefault />
    case PopType.RePop:
      return <RePOPForm />
    case PopType.ChatGpt:
      return <PopGPT />
    case PopType.FakeRe:
      return <FakeRePop />
    case PopType.AiPop:
      return <AIPop />
    case PopType.AiRePop:
      return <AIRepopForm />
    default:
      return null
  }
}
